import React, { useContext, useEffect, useState, useRef } from 'react';
import { getCustomers, createBulkOrder, ListSalesOrder, getQuotationOrderDetail, getproductvalue, getQuotation, getInvoiceNumber, getTax, get_po_serial_number, ProductReturn, postGeneralData } from '../../../Utility/Api';
import '../../../Utility/pagination.css';
import { WarehouseContext } from '../../../Utility/UserContext';
import { Clock, getFormattedCurrentDate2, handlePrint, AmountInWords, onReqCreatePayment, setLocalStorage, shop_id, company_logo } from '../../../Utility/function';
import { toast } from 'react-toastify';
import PaymentModal from '../../Common/PaymentModal';
import CustomerAddModal from '../../Common/CustomerAddModal';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import CashModal from './modal/CashModal';
import CashCardModal from './modal/CashCardModal';
import CardModal from './modal/CardModal';
import { Pagination } from "../../Common/Functions";
import "./customtoogle.css"
import SerialNoGenerate from "../Purchase/modal/SerialNoGenerate"
const styles = {
  body: {
    width: "80mm",
    fontSize: "12px",
    fontFamily: "Arial, sans-serif",
    margin: "0 auto",
    padding: "5px",
    lineHeight: "1.1",
    textAlign: "center",
    background: "white"
  },
  textCenter: { textAlign: "center" },
  logo: { width: "50px", height: "auto", margin: "1px 0" },
  flexBetween: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  bold: { fontWeight: "bold" },
  textStart: { textAlign: "left", fontSize: "11px" },
  textEnd: { textAlign: "right" },
  hr: { margin: "0px", width: "100%", opacity: 1, color: 'black' },
  // hr: { border: ".8px solid black", margin: "1px 0", width: "100%" },
  table: { width: "100%", fontSize: "11px", borderCollapse: "collapse", textAlign: "center" },
  border: { border: "1px solid black", padding: "5px", marginTop: "2px", width: "100%" },
  borderbottom: { borderBottom: "1px solid black" },
  fontSize: { fontSize: "10px" },
};

const SalesWindow = () => {
  const navigate = useNavigate()
  const [Customer, setCustomer] = useState([]);
  const [taxes, setTax] = useState([]);
  const [previousDue, setPreviousDue] = useState(0);
  const [CustomerId, setCustomerId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTerm1, setSearchTerm1] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [isFocused, setIsFocused] = useState(false);
  const [show, setShow] = useState(false);
  const [Quotation, setQuotation] = useState(false);
  const [returnShow, setReturnShow] = useState(false);
  const [cashShow, setCashShow] = useState(false);
  const [cardShow, setCardShow] = useState(false);
  const [cashCardShow, setCashCardShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [unqui, setunqui] = useState();
  const [replaceID, setReplaceID] = useState();
  const [quId, setQUId] = useState();
  const { selectedWarehouse, showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem)
  const [data, setdata] = useState(shopItem);
  const modalRef = useRef();
  const modalContentRef = useRef(null);
  const [searchCustomerTerm, setSearchCustomerTerm] = useState();
  const [LPONO, setLPONO] = useState();
  const [OderList, setOder] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newpurchasequtation, setnewpurchasequtation] = useState({});
  const [purchaseUnit, setPurchaseUnit] = useState("1");
  const today = new Date();
  const customDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const [values, setValues] = useState({
    50: "",
    20: "",
    10: "",
    5: "",
    1: "",
    5: "",
    0.500: "",
    0.100: "",
  });
  const [vat, setVat] = useState(0);
  const [taxType, setTaxType] = useState("");

  const [showModal1, setShowModal1] = useState(false);
  const [showSerialnumber, setshowSerialnumber] = useState(false);

  const [dummySerials, setDummySerials] = useState([]);
  const [selectedSerials, setSelectedSerials] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [currentProduct, setCurrentProduct] = useState(null);

  const [companyInfo, setCompanyInfo] = useState({
    name: "Company Name",
    address: "123 Business Street, City, State 12345",
    phone: "(123) 456-7890",
    email: "info@yourcompany.com"
  });

  useEffect(() => {
    if (shopItem) {
      setCompanyInfo({
        name: shopItem?.title || "",
        address: shopItem?.Address || "123 Business Street, City, State 12345",
        phone: shopItem?.phone1 || "",
        email: shopItem?.email || ""
      })
    }

  }, [shopItem])

  const calculateTotal = () => {
    return Object.entries(values).reduce(
      (sum, [key, value]) => sum + (parseFloat(key) * (parseFloat(value) || 0)),
      0
    );
  };

  const handleChange1 = (e, key) => {
    const newValue = e.target.value.replace(/\D/, ""); // Allow only numbers
    setValues((prev) => ({ ...prev, [key]: newValue }));
  };

  useEffect(() => {
    fetchSuppliers();
    fetchProductValue(selectedWarehouse?.id)
  }, [selectedWarehouse]);

  useEffect(() => {
    fetchInvoiceNumber();
    fetchTax();
  }, []);

  const fetchInvoiceNumber = async () => {
    try {
      const response = await getInvoiceNumber(3)
      if (response.data && response.data.invoice_no) {
        setunqui(response.data.invoice_no);
      }
    } catch (error) {
      console.error('Error fetching Customers data:', error);

    }

    try {
      const res = await getInvoiceNumber(4)
      if (res.data && res.data.invoice_no) {
        setReplaceID(res.data.invoice_no);
      }
    } catch (error) {
      console.error('Error fetching Customers data:', error);

    }
  };

  const fetchOrders = async (id) => {
    try {
      const response = await ListSalesOrder(id, shopItem?.shop_id);
      if (response.data && response.data.data) {
        const product = response.data.data;
        setOder(product);
      }
    } catch (error) {
      console.error("Customer data:", error);
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        console.log("Customers", response.data.data);
        setCustomer(response.data.data);
      }
    } catch (error) {
      console.error("Error Fetching Customer data:", error);
    }
  };

  const fetchProductValue = async (ware_id) => {
    try {
      const response = await getproductvalue(ware_id, true, "", shopItem?.shop_id);
      if (response.data && response.data.data) {
         setProducts(response.data.data) 
       }
    } catch (err) {
      console.error(err);
      // pbkdf2_sha256$600000$DkFqYDIwy2wxNfcsXDzboD$ZoJ8/jLiN6paGJF1lHlZmKzUbCQ012MpWwy84jisg0s=
    }
  }

  const fetchTax = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTax(response.data.data);
        console.log("Tax", response.data.data)
      } else {
        toast.error('No Tax found.');
      }
    } catch (error) {
      console.error('Error fetching Tax:', error);
      toast.error('Error fetching Tax');
    }
  };

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [ReturnItem, setReturnItem] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [QuotationList, setQuotationList] = useState(0);
  const [printerType, setPrinterType] = useState("1");
  const [Overdiscount, setOverdiscount] = useState(0);
  const [OverdiscountType, setOverdiscountType] = useState("%");
  const [sNoShow, setSNoShow] = useState(false);
  const [count, setCount] = useState(0);
  const [sData, setSData] = useState([]);
  const [sIndex, setIndex] = useState(0);

  useEffect(() => {
    fetchQU();
  }, []);


  const handleSearch = async (text) => {
    if (text.length > 3 || text.length == 0) {
      fetchQU(1, text);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchQU(pageNumber);
  };

  const fetchQU = async (page = 1, text = searchTerm1) => {
    showLoader()
    try {
      const filters = {
        approval_status: "1"
      };
      const response = await getQuotation(page, text, shop_id, filters);
      if (response.data && response.data.data) {
        setQuotationList(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader()
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
      toast.error("Error fetching sales");
      hideLoader()
    }
  };
  const [isBoxBarcodeMatched, setIsBoxBarcodeMatched] = useState(false);

  let boxMatched = false;

  const filteredProducts =
    searchTerm.length === 0
      ? []
      : products.filter((product) => {
        const isBoxMatch = product.box_bar_code?.toLowerCase() === searchTerm.toLowerCase();

        if (isBoxMatch) {
          boxMatched = true;
        }

        return (
          product.status != 2 &&
          (
            product.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.product_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.barcode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            isBoxMatch
          )
        );
      });



  const handleAddProduct = (product, isBox = false, serials = [], isbox) => {
    if (isBox && product.total_remaining_qty < product.box_qty) return;

    let updatedProducts = [...selectedProducts];
    console.log(isbox);
    console.log(isBoxBarcodeMatched);


    if (isBoxBarcodeMatched) {
      const purchasePrices = serials.map(item => parseFloat(item.purchase_price));
      const avgPurchasePrice = purchasePrices.reduce((sum, price) => sum + price, 0) / purchasePrices.length;
      const groupSellingPrice = parseFloat(serials[0]?.selling_price || 0);
      const box_sales_cost = parseFloat(product?.box_sales_cost || 0);
      const warranty = parseFloat(serials[0]?.warranty || 0);

      const isDuplicate = updatedProducts.some(
        (item) =>
          item.product_id === product.product_id &&
          item.price == groupSellingPrice &&
          item.warranty == warranty
      );

      if (!isDuplicate || product?.is_quataion) {
        const newProduct = {
          ...product,
          qty: serials.length,
          boxqty: 1,
          sales_price: formatPrice(groupSellingPrice),
          price: formatPrice(groupSellingPrice),
          warranty: warranty,
          discount: product.discount || 0,
          discount_type: product.discount_type || 0,
          purchase_price: formatPrice(avgPurchasePrice),
          total: box_sales_cost,
          // total: serials.length * formatPrice(groupSellingPrice),
          purchase_total: serials.length * formatPrice(avgPurchasePrice),
          is_box: true, // ✅ Set box true only if barcode matched
          serial_number: JSON.stringify(serials),
          is_quataion: false
        };

        let prevProducts = updatedProducts;
        if (product?.is_quataion) {
          prevProducts = updatedProducts.filter((data) => data.product_id !== product.product_id);
        }

        updatedProducts = [...prevProducts, newProduct];
      }
    } else {
      // Group serials by selling price and warranty
      const groupedByPriceAndWarranty = serials.reduce((acc, item) => {
        const key = `${item.selling_price}_${item.warranty}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      Object.entries(groupedByPriceAndWarranty).forEach(([key, group]) => {
        const [sellingPrice, warranty] = key.split("_").map(parseFloat);

        const isDuplicate = updatedProducts.some(
          (item) =>
            item.product_id === product.product_id &&
            item.price == sellingPrice &&
            item.warranty == warranty
        );

        const purchasePrices = group.map(item => parseFloat(item.purchase_price));
        const avgPurchasePrice = purchasePrices.reduce((sum, price) => sum + price, 0) / purchasePrices.length;

        if (!isDuplicate || product?.is_quataion) {
          const newProduct = {
            ...product,
            qty: group.length,
            boxqty: 1,
            sales_price: formatPrice(sellingPrice),
            price: formatPrice(sellingPrice),
            warranty: warranty,
            discount: product.discount || 0,
            discount_type: product.discount_type || 0,
            purchase_price: formatPrice(avgPurchasePrice),
            total: group.length * formatPrice(sellingPrice),
            purchase_total: group.length * formatPrice(avgPurchasePrice),
            is_box: isBox,
            serial_number: JSON.stringify(group),
            is_quataion: false
          };

          let prevProducts = updatedProducts;
          if (product?.is_quataion) {
            prevProducts = updatedProducts.filter((data) => data.product_id !== product.product_id);
          }

          updatedProducts = [...prevProducts, newProduct];
        }
      });
    }

    console.log("updatedProducts", updatedProducts);
    setIsBoxBarcodeMatched(false)
    setSelectedProducts(updatedProducts);
    priceUpdate(updatedProducts);
  };


  useEffect(() => {
    priceUpdate();
  }, [vat]);

  useEffect(() => {
    priceUpdate();
  }, [ReturnItem]);


  const priceUpdate = (products = selectedProducts) => {
    // const grandTotal = products.reduce((sum, product) => sum + (parseFloat(product.total) || 0), 0);
    const grandTotal = products.reduce((sum, product) => {
      // if (product.is_box) {
      //   console.log('one');
      //   return sum + (parseFloat(product.box_sales_cost) || 0);
      // }
      return sum + (parseFloat(product.total) || 0);
    }, 0);

    const priceTotal = products.reduce((sum, product) => {
      if (product.is_box) {
        console.log('one one');
        return sum + (parseFloat(product.box_sales_cost) || 0);
      }
      return sum + (parseFloat(product.price * product.qty) || 0);
    }, 0);
    const taxRate = parseFloat(vat || 0) / 100;
    const taxAmount = Number(grandTotal) * taxRate;
    const totalWithTaxValue = Number(grandTotal) + Number(taxAmount);
    const returnTotal = ReturnItem.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0);
    var finalTotal = (totalWithTaxValue - returnTotal).toFixed(3);

    console.log(formatPrice(grandTotal));
    console.log(formatPrice(priceTotal));
    console.log(formatPrice(taxAmount));
    console.log(formatPrice(returnTotal));
    console.log(formatPrice(finalTotal));


    setTotals({
      withoutTax: formatPrice(grandTotal),
      priceTotal: formatPrice(priceTotal),
      taxAmount: formatPrice(taxAmount),
      returnTotal: formatPrice(returnTotal),
      withTax: formatPrice(finalTotal)
    });
  };

  const [totals, setTotals] = useState({
    withoutTax: 0,
    priceTotal: 0,
    taxAmount: 0,
    returnTotal: 0,
    withTax: 0,
  });

  const formatPrice = (price) => (!isNaN(Number(price)) ? Number(price).toFixed(3) : '0.0');

  const handleChange = (index, value, name) => {
    const updatedProducts = [...selectedProducts];
    updatedProducts[index] = {
      ...updatedProducts[index],
      [name]: value,
    };
    if (name == "boxqty") {
      updatedProducts[index] = {
        ...updatedProducts[index],
        ["qty"]: value * updatedProducts[index].box_qty,
        [name]: value,
      };
    }

    if (name === "qty" || name === "boxqty" || name === "price" || name === "discount" || name === "discount_type") {
      const is_box = updatedProducts[index].is_box;
      const box_qty = parseFloat(updatedProducts[index].box_qty) || 0;
      const boxqty = parseFloat(updatedProducts[index].boxqty) || 0;
      const boxsalesrate = parseFloat(updatedProducts[index].box_sales_cost) || 0;
      const qty = parseFloat(updatedProducts[index].qty) || 0;
      const price = parseFloat(updatedProducts[index].is_box ? updatedProducts[index].box_sales_cost : updatedProducts[index]?.price) || 0;
      const discount = parseFloat(updatedProducts[index].discount) || 0;
      const discountType = updatedProducts[index].discount_type; // 0 = Cash, 1 = Percentage

      let total = is_box ? boxsalesrate : qty * price;


      if (discount > 0) {
        if (discountType == 1) {
          total -= (total * discount) / 100;
        } else {
          total -= discount;
        }
      }
      console.log("Total===>", total);


      updatedProducts[index].discount = discount; // Prevent negative total
      updatedProducts[index].total = formatPrice(Math.max(total, 0)); // Prevent negative total

    }

    console.log(updatedProducts[index]);


    setSelectedProducts(updatedProducts);
    console.log(updatedProducts);


    const grandTotal = updatedProducts.reduce((sum, product) => sum + (parseFloat(product.total) || 0), 0);
    const priceTotal = updatedProducts.reduce((sum, product) => {
      if (product.is_box) {
        return sum + (parseFloat(product.box_sales_cost) || 0);
      }
      return sum + (parseFloat(product.price) * (product.qty || 0) || 0);
    }, 0);

    const taxRate = parseFloat(vat || 0) / 100;
    const taxAmount = Number(grandTotal) * taxRate;
    const totalWithTaxValue = Number(grandTotal) + Number(taxAmount);
    const returnTotal = ReturnItem.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0);
    var finalTotal = (totalWithTaxValue - returnTotal).toFixed(3);

    console.log(formatPrice(grandTotal));
    console.log(formatPrice(priceTotal));
    console.log(formatPrice(taxAmount));
    console.log(formatPrice(returnTotal));
    console.log(formatPrice(finalTotal));


    setTotals({
      withoutTax: formatPrice(grandTotal),
      priceTotal: formatPrice(priceTotal),
      taxAmount: formatPrice(taxAmount),
      returnTotal: formatPrice(returnTotal),
      withTax: formatPrice(finalTotal)
    });
  };

  const handleRemoveProduct = (index) => {
    setSelectedProducts((prevProducts) => {
      const updatedProducts = prevProducts.filter((_, i) => i !== index);
      priceUpdate(updatedProducts);
      return updatedProducts;
    });
  };

  const [successModal, setSuccessModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);

  const handleSubmit = async (type = "1") => {
    const grandTotal = amountDue2;
    const purchaseTotal = selectedProducts.reduce((sum, product) => sum + (parseFloat(product.purchase_total) || 0), 0);
    let pendingAmount = Math.abs(parseFloat(getReminingValue())).toFixed(3);
    let paidAmount = parseFloat(grandTotal).toFixed(3);
    let purchase_type = "0";
    var total_amount = amountDue2;
    var profit_loss = grandTotal - purchaseTotal;
    console.log("grandTotal", grandTotal);
    console.log("purchaseTotal", purchaseTotal);
    console.log("profit loss", grandTotal - purchaseTotal);

    if (shopItem.vat_no && !vat) {
      toast.error("Tax type is required");
      return;
    }

    if (parseFloat(input) < grandTotal) {
      paidAmount = input;
      purchase_type = "2";
    } else {
      purchase_type = type;
    }

    if (type == "2") {
      paidAmount = 0;
      pendingAmount = grandTotal;
    }

    if (!CustomerId && pendingAmount > 0 && type != "5") {
      toast.error("Customer details are required for credit sales.");
      return
    };

    let paydata = {
      orderID: unqui,
      date: getFormattedCurrentDate2(),
      amount: "0",
      total_amount: amountDue2,
      cash: 0,
      credit: 0,
      card: 0,
      type: 2,
      mop: "0",
      complete: "0",
    };

    var invoiceData = [];

    const paymentModes = {
      "1": () => {
        if (pendingAmount > 0) {
          Object.assign(paydata, { cash: paidAmount, credit: pendingAmount, mop: "1,2" });
          purchase_type = "2";
          invoiceData = [
            { mop: "Cash", amount: paidAmount },
            { mop: "Remaining Amount", amount: pendingAmount },
          ]
        } else {
          Object.assign(paydata, { cash: paidAmount, mop: "1" });
          purchase_type = "1";
          invoiceData = [
            { mop: "Cash", amount: paidAmount },
          ]
          paydata.complete = "1";
        }
      },
      "2": () => {
        Object.assign(paydata, { cash: paidAmount, credit: pendingAmount, mop: "2" });
        purchase_type = "2"
        invoiceData = [
          { mop: "Remaining Amount", amount: pendingAmount },
        ]
      },
      "4": () => {
        if (pendingAmount > 0) {
          Object.assign(paydata, { cash: 0, credit: pendingAmount, card: paidAmount, mop: "2,4" });
          purchase_type = "2"
          invoiceData = [
            { mop: "Card", amount: paidAmount },
            { mop: "Remaining Amount", amount: pendingAmount },
          ]
        } else {
          Object.assign(paydata, { cash: 0, credit: 0, card: paidAmount, mop: "4" });
          purchase_type = "1"
          invoiceData = [
            { mop: "Card", amount: paidAmount },
          ]
          paydata.complete = "1";
        }
      },
      "5": () => {
        purchase_type = "1";
        paydata.complete = "1";
        Object.assign(paydata, { cash: paidAmount, card: pendingAmount > 0 ? pendingAmount : 0, mop: pendingAmount > 0 ? "1,4" : "1" });
        if (pendingAmount > 0) {
          invoiceData = [
            { mop: "Cash", amount: paidAmount },
            { mop: "Card", amount: pendingAmount },
          ]
        } else {
          invoiceData = [
            { mop: "Cash", amount: paidAmount },
          ]
        }
      }
    };

    paymentModes[type]?.();
    setPurchaseUnit(purchase_type);
    setInvoiceData(invoiceData);

    const payload = {
      customer_id: CustomerId || 0,
      supplier_id: profit_loss || 0,
      products: selectedProducts,
      total: totals,
      total_amount: total_amount,
      vat,
      discount: OverdiscountType === "%"
        ? ((totals.withTax - discount) * Overdiscount / 100).toFixed(3)
        : (parseFloat(discount) + parseFloat(Overdiscount || 0)).toFixed(3),
      card_type: JSON.stringify({
        type: OverdiscountType,
        value: Overdiscount
      }),
      subtotal: grandTotal,
      sub_total: grandTotal,
      warehouse_id: selectedWarehouse?.id,
      user_id: user?.user_id,
      unique_id: unqui,
      qu_id: quId,
      shop_id: shopItem?.shop_id + "",
      ReturnItem: [],
      cash: JSON.stringify({ total: getAmountDue(), customer_given: input, returned: getReturnValue() }),
      purchase_unit: purchase_type,
      lpo_no: LPONO,
      sales_remaining: purchase_type === "2" ? grandTotal : 0,
      amount: purchase_type == "2" ? paidAmount : purchase_type == "5" ? grandTotal : 0,
      remaining: 0
    };


    const returnPayload = transformData(ReturnItem);

    console.log("ReturnItem", ReturnItem);
    console.log("BulkOrder", payload);
    console.log("returnPayload", returnPayload);

    setReturnShow(false);
    setCashShow(false);
    setCashCardShow(false);
    setCardShow(false);
    showLoader();
    setShowModal(true);
    setSuccessModal(true);

    try {
      const response = await createBulkOrder(payload);
      if (returnPayload.serial_number != "[]") {
        await ProductReturn(returnPayload);
      }
      if (response.data) {
        await onReqCreatePayment(paydata);
        try {
          const generalDataPayload1 = {
            type: "3",
            ref_id: 'INV_' + unqui,
            remarks: "Inventory Sales",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: purchaseTotal,
            is_debit: "0",
          };

          await postGeneralData(generalDataPayload1);

          const generalDataPayload2 = {
            type: "4",
            ref_id: 'COGS_' + unqui,
            remarks: "Inventory COGS",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: purchaseTotal,
            is_debit: "1",
          };

          await postGeneralData(generalDataPayload2);
        } catch (e) {
          console.error("General log failed:", e);
          toast.error("Failed to create general transaction log");
        }

        setTimeout(() => {
          printerType === "0" ? handlePrint1() : handlePrint(modalContentRef);
          setTimeout(() => {
            Resetbutton();
            toast.success("Data Stored Successfully");
            hideLoader();
            setReturnItem([]);
            setQUId("");
            setShowModal(false);
            setSuccessModal(false);
            hideLoader();
          }, 3000);
        }, 10);
      } else {
        hideLoader();
      }
    } catch (err) {
      console.error("Error:", err);
      const errorMessage = err.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);

      hideLoader();
      setQUId("");
      setShowModal(false);
      setSuccessModal(false);
    }
  };

  const Resetbutton = () => {
    setSelectedProducts([])
    setTotals({
      withoutTax: 0,
      priceTotal: 0,
      taxAmount: 0,
      returnTotal: 0,
      withTax: 0
    })
    setReturnItem([]);
    window.location.reload();
  }

  const calculateDiscount = () => {
    // if (discountType === "per") {
    //   return (totals.withoutTax * discountValue) / 100;
    // } else if (discountType === "cash") {
    //   return parseFloat(discountValue);
    // }
    return 0;
  };

  const discount = calculateDiscount();
  const filteredCustomers = searchCustomerTerm
    ? Customer.filter(item =>
      item.status != 1 && item.name.toLowerCase().includes(searchCustomerTerm.toLowerCase())
    )
    : Customer.filter(item => item.status != 1);

  const overDiscountAmount = OverdiscountType === "%"
    ? ((totals.withTax - discount) * Overdiscount / 100)
    : Overdiscount;

  const overDiscountValue = OverdiscountType === "%"
    ? ((totals.withTax - discount) * Overdiscount / 100)
    : Overdiscount;

  const amountDue2 = (totals.withTax - discount - overDiscountValue).toFixed(3);

  const [searchText, setSearchText] = useState('');
  const [filters, setFilters] = useState({
    searchByInvoice: true,
    searchByProduct: true,
    searchByDate: false,
  });
  const [returnQuantities, setReturnQuantities] = useState({});

  const InvoiceSearch = (OderList, ReturnItem, setReturnItem) => {

    const handleFilterChange = (e) => {
      setFilters({
        ...filters,
        [e.target.name]: e.target.checked,
      });
    };

    const getMaxReturnableQty = (itemId) => {
      const item = OderList.find(item => item.id === itemId);
      if (!item) return 0;

      const existingReturn = ReturnItem.find(ri => ri.id === itemId);
      const alreadyReturnedQty = existingReturn ? existingReturn.returnQty : 0;

      return parseInt(item.qty) - alreadyReturnedQty;
    };

    const filteredOrders = OderList.filter((item) => {
      if (searchText === '') return true;

      return (
        (filters.searchByInvoice && item.unique_id.toLowerCase().includes(searchText.toLowerCase())) ||
        (filters.searchByProduct && item.product_name.toLowerCase().includes(searchText.toLowerCase())) ||
        (filters.searchByDate && item.date.toLowerCase().includes(searchText.toLowerCase()))
      );
    });

    const handleAddReturnItem = (item) => {
      const returnQty = (returnQuantities[item.id] || []).length;
      if (returnQty <= 0) return;

      const singleItemPrice = parseFloat(item.amount_per_price) / parseInt(item.qty);
      const returnAmount = singleItemPrice * returnQty;
      const parse_serial = JSON.parse(item.serial_number) || [];
      const selected_serials = returnQuantities[item.id] || [];

      const remaining_serials = parse_serial.filter(
        serial => !selected_serials.includes(serial)
      );
      setReturnItem((prev) => [
        ...prev,
        {
          ...item,
          returnQty,
          returnSerialNumber: JSON.stringify(returnQuantities[item.id]),
          serial_number: JSON.stringify(remaining_serials),
          returnAmount: returnAmount.toFixed(3),
          originalQty: item.qty,
          originalAmount: item.amount_per_price,
          unitPrice: singleItemPrice.toFixed(3),
          split_discount: parseFloat(item.discount) / parseInt(item.qty)
        }
      ]);

      setReturnQuantities(prev => {
        const newState = { ...prev };
        delete newState[item.id];
        return newState;
      });
    };

    const toggleSerialNumber = (itemId, serialObj) => {
      setReturnQuantities(prev => {
        const currentSerials = prev[itemId] || [];
        const serialNumber = serialObj?.serial_number || serialObj;

        // Check if this serial number already exists in the selected items
        const existingIndex = currentSerials.findIndex(s =>
          (s?.serial_number || s) === serialNumber
        );

        const updatedSerials = existingIndex >= 0
          ? currentSerials.filter((_, index) => index !== existingIndex)
          : [...currentSerials, serialObj]; // Store the full object

        return {
          ...prev,
          [itemId]: updatedSerials
        };
      });
    };

    function getParsedSerialNumbers(rawSerialNumber) {
      try {
        if (!rawSerialNumber) return [];
        const parsed = JSON.parse(rawSerialNumber);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error("Failed to parse serial numbers:", e);
        return [];
      }
    }

    return (
      <div>
        <div className="mb-3">
          <input
            type="text"
            placeholder="Search Invoice Number, Customer, or Date"
            className="form-control"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="me-3">Filter by:</label>
          <div className="form-check form-check-inline">
            <input
              type="checkbox"
              className="form-check-input"
              id="searchByInvoice"
              name="searchByInvoice"
              checked={filters.searchByInvoice}
              onChange={handleFilterChange}
            />
            <label className="form-check-label" htmlFor="searchByInvoice">
              Invoice Number
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="checkbox"
              className="form-check-input"
              id="searchByProduct"
              name="searchByProduct"
              checked={filters.searchByProduct}
              onChange={handleFilterChange}
            />
            <label className="form-check-label" htmlFor="searchByProduct">
              Product Name
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="checkbox"
              className="form-check-input"
              id="searchByDate"
              name="searchByDate"
              checked={filters.searchByDate}
              onChange={handleFilterChange}
            />
            <label className="form-check-label" htmlFor="searchByDate">
              Date
            </label>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Invoice Number</th>
                <th>Product Name</th>
                <th>Total Qty</th>
                <th>Return Qty</th>
                <th>Unit Price</th>
                <th>Total Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.length > 0 ? (
                filteredOrders
                  .filter(order => {
                    try {
                      const parsedSerials = JSON.parse(order.serial_number);
                      return Array.isArray(parsedSerials) &&
                        parsedSerials.length > 0 &&
                        parsedSerials[0].serial_number;
                    } catch (e) {
                      return false;
                    }
                  })
                  .filter(item => !ReturnItem.some(returnItem => returnItem.id === item.id))
                  .map((item) => {
                    const maxReturnable = getMaxReturnableQty(item.id);
                    const singleItemPrice = parseFloat(item.amount_per_price) / parseInt(item.qty);
                    // const currentQty = returnQuantities[item.id] || 0;
                    const currentQty = (returnQuantities[item.id] || []).length;

                    return (
                      <tr key={`${item.unique_id}-${item.id}`}>
                        <td>{item.unique_id}</td>
                        <td
                          style={{
                            maxWidth: "20px",
                            overflow: "hidden"
                          }}
                        >{item.product_name}</td>
                        <td>{item.qty}</td>
                        <td>
                          {(() => {
                            const serialNumbers = getParsedSerialNumbers(item?.serial_number);

                            if (!Array.isArray(serialNumbers)) {
                              return <p>No serial numbers</p>;
                            }

                            const selectedSerials = returnQuantities[item.id] || [];
                            const currentQty = selectedSerials.length;

                            return (
                              <>
                                {serialNumbers.filter((s) => s.status != "1").map((serialObj, index) => {
                                  const serialNumber = serialObj?.serial_number || serialObj;
                                  const isSelected = selectedSerials.some(s =>
                                    (s?.serial_number || s) === serialNumber
                                  );

                                  return (
                                    <p key={index}>
                                      <button
                                        type="button"
                                        className={`btn min-w-[25%] max-w-fit m-0 py-1 ${isSelected ? 'btn-success' : 'btn-primary'}`}
                                        onClick={() => toggleSerialNumber(item.id, serialObj)}
                                      >
                                        {serialNumber}
                                      </button>
                                    </p>
                                  );
                                })}
                                {currentQty > 0 && <small className="text-muted">Selected: {currentQty}</small>}
                              </>
                            );
                          })()}
                        </td>


                        <td>{singleItemPrice.toFixed(3)}</td>
                        <td>{item.amount_per_price}</td>
                        <td>
                          <button
                            className='btn btn-primary btn-sm'
                            onClick={() => handleAddReturnItem(item)}
                            disabled={maxReturnable <= 0 || !returnQuantities[item.id]}
                          >
                            Add
                          </button>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No items found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = () => {
    const invalidProducts = selectedProducts.filter(product => {
      try {
        const serials = JSON.parse(product.serial_number);
        const qty = Number(product?.is_box ? product.boxqty : product.qty);
        return !Array.isArray(serials) || serials.length !== qty;
      } catch (e) {
        return true; // if JSON.parse fails, it's invalid
      }
    });

    if (invalidProducts.length > 0) {
      const productNames = invalidProducts.map(p => p.product_name).join(', ');
      toast.error(`Please add correct serial numbers for: ${productNames}`);
      return;
    }

    setShowModal(true);
  };

  const removeItem = (id) => {
    setReturnItem(preState => preState.filter((item) => item.id !== id));
  };

  const GetPurchaseData = async (Quotation) => {
    var res = await getQuotationOrderDetail(Quotation?.quotation_number);
    var dataList = res.data.data;
    var updatedProducts = []
    console.log("Quotation", Quotation)
    console.log(parseInt(Quotation?.supplier_id || 0))
    if (dataList.length) {
      // Demo Durai
      if (Quotation.discount != 0) {
        setOverdiscountType("%")
        setOverdiscount(Quotation.discount)
      } else {
        setOverdiscountType("%")
        setOverdiscount("0")

      }
      setQUId(Quotation?.quotation_number)
      setCustomerId(parseInt(Quotation?.supplier_id || 0))
      fetchOrders(Quotation?.customer_name);
      setSearchCustomerTerm(Quotation.customer_name);
      updatedProducts = dataList.map(item => (
        {
          qty: item.qty,
          product_name: item.product_name,
          product_id: item.product_id,
          product_code: item.product_code,
          boxqty: 1,
          sales_price: formatPrice(item.price),
          price: formatPrice(item.price),
          discount: item.discount,
          discount_type: 0,
          purchase_price: item.price,
          total: item.price * item.qty,
          is_box: false,
          is_quataion: true
        }
      ))
    }
    console.log(updatedProducts);
    setSelectedProducts(updatedProducts);
    priceUpdate(updatedProducts);
    setQuotation(false)
  }

  const [showPayModal, setShowPayModal] = useState(false);

  const handlePaymentType = (type) => {
    console.log(`Payment method selected: ${type}`);
    setPurchaseUnit(type);

    if (type == "1") {
      setCashShow(true);
      setInput("");
      setValues({
        50: "",
        20: "",
        10: "",
        5: "",
        1: "",
        5: "",
        0.500: "",
        0.100: "",
      })
    } else if (type == "2") {
      if (CustomerId) {
        handleSubmit(type)
      } else {
        toast.error("Customer details are required for credit sales.")
      }
    } else if (type == "5") {
      setCashCardShow(true);
      setInput("");
    } else if (type == "4") {
      setCardShow(true);
      setInput("");
    }
    setShowPayModal(false);
  };

  const [showCustomer, setShowCustomer] = useState(false);
  const [input, setInput] = useState("");

  const handleClick = (value) => {
    setInput((prev) => {
      if (value === ".") {
        if (prev.includes(".") || prev === "") return prev;
      }
      return prev + value;
    });
  };

  const handleBackspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const handleConfirm = () => {
    alert(`Entered Number: ${input}`);
  };

  const getAmountDue = () => (Number(amountDue2).toFixed(3))

  const getReturnValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue?.toFixed(3);

    return input && !isNaN(input) && /^\d+(\.\d{1,2})?$/.test(input) && parseFloat(input) >= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const getReminingValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue?.toFixed(3);

    return input && !isNaN(input) && /^\d+(\.\d{1,2})?$/.test(input) && parseFloat(input) <= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const [printOpen, setPrintOpen] = useState(false);

  const handleSelectPrinter = (type) => {
    // setLocalStorage('PrinterType', type)
    // setPrinterType(type)
    // setPrintOpen(false);
  }

  const componentRef = useRef(null);

  const handlePrint1 = async () => {
    const content = componentRef.current;

    if (!content) {
      console.error("Modal content not found for printing");
      return;
    }

    try {
      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");

      const contentHeightMm = (canvas.height * 80) / canvas.width;
      const pageHeight = 210;

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [80, contentHeightMm], // Set dynamic height
      });

      let yOffset = 5;
      pdf.addImage(imgData, "PNG", 1, yOffset, 78, contentHeightMm, undefined, 'FAST');
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(pdfUrl, "_blank");

      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      } else {
        console.error("Failed to open the print window");
      }

      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Error generating the receipt PDF:", error);
    }
  };

  const fetch_po_serial_id = async (PO_ID, is_box = false, update = false) => {
    try {
      const response = await get_po_serial_number(PO_ID);
      console.log("boxbarmatch?", is_box)
      console.log("product?", currentProduct)

      if (response.data.data) {
        // const Serialvalue = response?.data.data.map((data, index) => data.serial_number);
        const Serialvalue = response?.data.data;
        console.log("Serial Number", Serialvalue)
        const today = new Date();
        const validSerials = Serialvalue.filter(serial => {
          const expiry = new Date(serial.expiry_date);
          return expiry >= today; // Keep only non-expired
        });

        setDummySerials(validSerials);
        setSelectedSerials([]);
        setSelectedCount(0);
        setShowModal1(true);
      } else {
        toast.error('Serial Number No found.');
      }
    } catch (error) {
      console.error('Error fetching Serial Number:', error);
      toast.error('Error fetching Serial Number');
    }
  };

  const [searchTermvalue, setSearchTermvalue] = useState("");

  const filteredSerials = dummySerials.filter((serial) =>
    serial?.serial_number.toLowerCase().includes(searchTermvalue.toLowerCase())
  );

  const openSerialModal = async (product, is_quation = false, update = false) => {
    if (product.box_bar_code == searchTerm) {
      setIsBoxBarcodeMatched(true);
    } else {
      setIsBoxBarcodeMatched(false);
    }
    await fetch_po_serial_id(product?.product_id, product.box_bar_code == searchTerm, product)
    setCurrentProduct(product);
  };

  // const toggleSerial = (serial) => {

  //   setSelectedSerials((prev) => {
  //     let updated;
  //     if (prev.includes(serial)) {
  //       updated = prev.filter((s) => s !== serial);
  //     } else {
  //       updated = [...prev, serial];
  //     }
  //     setSelectedCount(updated.length); // Update count
  //     return updated;
  //   });

  // };

  const toggleSerial = (serial) => {
    setSelectedSerials((prev) => {
      let updated;

      if (prev.includes(serial)) {
        updated = prev.filter((s) => s !== serial);
      } else {
        // Prevent over-selecting when box barcode is matched
        if (isBoxBarcodeMatched && prev.length >= currentProduct.box_qty) {
          return prev; // Block adding more than box_qty
        }
        updated = [...prev, serial];
      }

      setSelectedCount(updated.length);
      return updated;
    });
  };


  const submitSelectedSerials = () => {
    const isBox = currentProduct?.box_bar_code
      ?.toLowerCase() === (searchTerm.toLowerCase());
    // setIsBoxBarcodeMatched(false)
    console.log(currentProduct);

    console.log(selectedSerials)
    if (currentProduct?.is_quataion) {
      console.log(currentProduct?.qty)
      if (currentProduct?.qty != selectedSerials.length) {
        alert("Your quantity and selected serial number is miss matched");
      } else {
        handleAddProduct(currentProduct, false, selectedSerials, isBox);
        setShowModal1(false);
      }
    } else {
      handleAddProduct(currentProduct, false, selectedSerials, isBox);
      setShowModal1(false);
    }
  };

  const Paybutton = () => {
    const updatedProducts = selectedProducts.map(product => {
      try {
        let serials = JSON.parse(product.serial_number);
        const qty = Number(product?.is_box ? product.boxqty : product.qty);

        if (Array.isArray(serials) && serials.length === 0 && qty > 0) {
          serials = Array.from({ length: qty }, (_, i) => i + 1);
          return {
            ...product,
            serial_number: JSON.stringify(serials), // store as JSON string if expected
          };
        }

        return product;
      } catch (e) {
        // If parse fails, mark serial as invalid JSON string
        return {
          ...product,
          serial_number: "[]",
        };
      }
    });

    console.log(updatedProducts);


    // Update selected products with corrected serials
    setSelectedProducts(updatedProducts);

    // Now validate
    const invalidProducts = updatedProducts.filter(product => {
      try {
        const serials = JSON.parse(product.serial_number);
        const qty = Number(product?.is_box ? product.box_qty : product.qty);
        return !Array.isArray(serials) || serials.length !== qty;
      } catch (e) {
        return true;
      }
    });

    if (invalidProducts.length === 0) {
      console.log(invalidProducts);
      setShowPayModal(true);
    } else {
      const productNames = invalidProducts.map(p => p.product_name).join(', ');
      toast(`These products do not have correct serial numbers:\n${productNames}`);
    }
  };


  const transformData = (inputArray) => {
    const result = {
      replace_id: unqui,
      serial_number: [],
      invoice_number: [],
      amount: "0",
      sales_update: [],
      unique_id: replaceID,
      user_id: user?.user_id || "",
      shop_id: String(shopItem?.id || ""),
      type: "0"
    };

    let totalAmount = 0;
    const seenSerials = new Set();

    inputArray.forEach(item => {
      const originalSerials = Array.isArray(item.serial_number)
        ? item.serial_number
        : JSON.parse(item.serial_number || "[]");

      const returnSerials = Array.isArray(item.returnSerialNumber)
        ? item.returnSerialNumber
        : JSON.parse(item.returnSerialNumber || "[]");

      result.invoice_number.push({
        unique_id: item.unique_id,
        serial_number: returnSerials.map(s => typeof s === 'object' ? s.serial_number : s),
        product_name: item.product_name
      });

      const processedSerials = {};

      originalSerials.forEach(serial => {
        const serialNum = typeof serial === 'object' ? serial.serial_number : serial;
        processedSerials[serialNum] = {
          ...(typeof serial === 'object' ? serial : {}),
        };
      });

      returnSerials.forEach(serial => {
        const serialObj = typeof serial === 'object' ? serial : { serial_number: serial };
        const serialNum = serialObj.serial_number;

        totalAmount += parseFloat(serialObj.selling_price || item.sales_price || 0);

        if (!seenSerials.has(serialNum)) {
          result.serial_number.push(serialNum);
          seenSerials.add(serialNum);
        }

        processedSerials[serialNum] = {
          ...serialObj,
          status: "1"
        };
      });

      result.sales_update.push({
        id: item.id,
        serial_number: Object.values(processedSerials)
      });
    });

    result.amount = totalAmount.toFixed(3);
    result.serial_number = JSON.stringify(result.serial_number);
    result.invoice_number = JSON.stringify(result.invoice_number);
    result.invoice_number = JSON.stringify(result.invoice_number);
    result.return_data = JSON.stringify(inputArray);

    return result;
  };

  return (
    <>
      {/* white */}
      <div className="page-wrappers">
        <div className="row mx-0" style={{ width: "100vw", height: "90vh", background: "white" }}>
          <div className="mx-0" style={{ width: "70vw", height: "90vh", background: "white" }}>
            <div className="mx-0" style={{ width: "100%", height: "70vh", background: "white" }}>
              <div className="mx-0" style={{ width: "100%", height: "30%", background: "white" }}>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <div className='font-weight-1 font-18'>
                      Sales ID : {unqui}
                    </div>
                  </div>
                  <div className='font-weight-1 font-18'>
                    Date & Time:
                    {new Date().toLocaleDateString()}
                    {" "}
                    {/* {new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })} */}
                    {Clock()}
                  </div>
                  {/* <label className="switch1">
                    <input
                      type="checkbox"
                      onChange={handleToggle}
                      checked={printerType == "0"}
                    />
                    <span className="slider"></span>
                  </label> */}
                </div>
                <div className="row justify-content-center px-2 row-gap-1 pt-2" >
                  <div className="col-md-4 px-1">
                    {/* <div className='d-flex align-items-center column-gap-2 flex-column'> */}
                    <div className='d-flex flex-column'>
                      <label>Customer:</label>
                      <div className='d-flex align-items-center column-gap-2'>
                        <div className="dropdown w-100">
                          <input
                            className="w-100 clo-6"
                            type="text"
                            placeholder="Search Customer"
                            value={searchCustomerTerm}
                            onChange={(e) => setSearchCustomerTerm(e.target.value)}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          />
                          <button
                            type="button"
                            className="btn btn-sm position-absolute top-50 end-0 translate-middle-y"
                            onClick={() => setShowCustomer(true)}
                            style={{ border: "none", background: "transparent" }} >
                            <i className="bi bi-plus-circle fs-6 text-primary"></i>
                          </button>

                          <ul className="dropdown-menu w-100 p-1" style={{ maxHeight: '300px', overflowY: 'scroll' }} aria-labelledby="dropdownMenuButton">
                            {filteredCustomers
                              .map((item) => (
                                <div
                                  key={item.customer_id}
                                  className="col-md-12"
                                  onClick={() => {
                                    setCustomerId(item.customer_id);
                                    setPreviousDue(item.last_remaining);
                                    fetchOrders(item.customer_id);
                                    setSearchCustomerTerm(item.name);
                                  }}
                                >
                                  <div className="card mb-1 shadow-sm">
                                    <div className="card-body p-1">
                                      <h5 className="card-title font-14 mb-0">{item.name}</h5>
                                      <p className="card-text font-13">
                                        <strong>Branch:</strong> {item.branch} <br />
                                        <strong>Phone:</strong> {item.phone}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    {/* <div className={`form-group mb-1 d-flex align-items-center col-${12}`}> */}
                    <div className={`form-group mb-1 d-flex flex-column col-${12}`}>
                      <label className="col-10">L.P.O No:</label>
                      <div className="col-10">
                        <input
                          className="w-100"
                          placeholder="Enter L.P.O No"
                          value={LPONO}
                          onChange={(e) => setLPONO(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className={`form-group mb-1 d-flex flex-column col-${12}`}>
                      <label className="col-12">Tax Type:</label>
                      <div className="col-10">
                        <select
                          className="w-100"
                          value={taxType}
                          onChange={(e) => {
                            const { name, value } = e.target
                            console.log(name, value);
                            setTaxType(value);
                            setVat(taxes.find(item => item.id == value)?.value || 0);
                          }}
                          required
                        >
                          <option value="" >Select Tax</option>
                          {taxes.map((option, index) => (
                            <option key={index} value={option.id}>
                              {option.title || ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-10 position-relative ">
                    <div>
                      <div style={{ position: 'relative', display: 'inline-block', maxHeight: '"60vh' }} className='w-100 '  >
                        <input
                          type="text"
                          className='w-100'
                          placeholder="Search | Product Name | Product Code"
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => { setIsFocused(false); setSearchTerm('') }}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{
                            borderRadius: '1px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <img
                          src="/assets/images/icons/search.png"
                          alt="Search Icon"
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            height: '18px',
                            pointerEvents: 'none',
                          }}
                          onClick={(e) => setSearchTerm()}
                        />
                      </div>
                      <div onMouseDown={(e) => e.preventDefault()} >
                        {true && filteredProducts.length > 0 && (
                          <table className="table table-bordered position-absolute " style={{
                            zIndex: 9999, maxHeight: '20vh',
                            overflowY: 'auto',
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                          }}>
                            <tbody >
                              {filteredProducts
                                .filter(
                                  (item) =>
                                    !selectedProducts.map((selected) => selected.product_id).includes(item.product_id)
                                )
                                .filter((data) => data.product_name != null && data.product_name && data.total_remaining_qty > 0)
                                .slice(0, 9)
                                .map((product, index) => (
                                  <tr key={product.product_id}>
                                    <td
                                      style={{
                                        width: "420px",
                                        overflowWrap: "breakWord"
                                      }}
                                    >
                                      {product.product_name}
                                    </td>
                                    <td>
                                      {/* <button className="btn-danger w-50" onClick={() => handleAddProduct(product, product.box_bar_code?.toLowerCase().includes(searchTerm.toLowerCase()))}> */}
                                      <button className="btn-danger w-50" onClick={() => openSerialModal(product)}>
                                        Add
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {showModal1 && (
                  <div
                    className="modal-backdrop"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      zIndex: 9999,
                      overflowY: "auto",
                      paddingTop: "60px",
                    }}
                  >
                    <div
                      className="modal-content p-4 rounded shadow"
                      style={{
                        background: "#fff",
                        maxWidth: "550px",
                        width: "100%",
                        margin: "0 auto",
                      }}
                    >
                      <h5 className="mb-3">Select Serial Numbers</h5>
                      <p className="text-muted">
                        Selected: <strong>{selectedCount}</strong>
                      </p>
                      {isBoxBarcodeMatched &&
                        <p className="text-muted">
                          Select Exact : <strong>{currentProduct?.box_qty}</strong>
                        </p>}

                      {/* 🔍 Search input */}
                      <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Search serial number..."
                        value={searchTermvalue}
                        onChange={(e) => setSearchTermvalue(e.target.value)}
                      />

                      {/* 📜 Scrollable list */}
                      <div
                        className="serial-list d-flex flex-wrap gap-2 align-item-center justify-content-center mb-4"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        {filteredSerials.map((serial, index) => (
                          <button
                            key={index}
                            className={`btn btn-sm w-40 ${selectedSerials.includes(serial)
                              ? "btn-success"
                              : "btn-outline-secondary"
                              }`}
                            onClick={() => toggleSerial(serial)}
                          >
                            {serial?.serial_number}
                            <span className='text-danger'> ({serial?.selling_price})</span>
                          </button>
                        ))}
                      </div>

                      <div className="text-end">
                        <button
                          className="btn btn-secondary me-2"
                          onClick={() => { setShowModal1(false); setIsBoxBarcodeMatched(false) }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={submitSelectedSerials}
                          disabled={selectedSerials.length === 0 ||
                            (isBoxBarcodeMatched && selectedSerials.length != currentProduct.box_qty)
                          }>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>

                )}



                {showSerialnumber && (
                  <div
                    className="modal-backdrop"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      zIndex: 9999,
                      overflowY: "auto",
                      paddingTop: "60px",
                    }}
                  >
                    <div
                      className="modal-content p-4 rounded shadow"
                      style={{
                        background: "#fff",
                        maxWidth: "500px",
                        width: "100%",
                        margin: "0 auto",
                      }}
                    >
                      <h5 className="mb-3">Select Serial Numbers</h5>


                      {/* 📜 Scrollable list */}
                      <div
                        className="serial-list d-flex flex-wrap gap-2 mb-4"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        {selectedSerials.map((serial, index) => (
                          <button
                            key={index}
                            className={`btn btn-sm btn-success`}>
                            {serial.serial_number}
                          </button>
                        ))}
                      </div>

                      <div className="text-end">
                        <button
                          className="btn btn-secondary me-2"
                          onClick={() => setshowSerialnumber(false)}
                        >
                          Ok
                        </button>

                      </div>
                    </div>
                  </div>

                )}



              </div>
              <div className="mx-0" style={{ width: "100%", height: "70%", background: "white", overflow: 'hidden', overflowY: 'scroll' }}>
                <div className="table-responsive my-1 w-100 position-relative">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Price (INR)</th>
                        <th>Dis Type</th>
                        <th>Discount</th>
                        <th>Warranty</th>
                        <th>Serial</th>
                        <th>Total Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProducts.length > 0 ? (
                        selectedProducts.map((product, index) => (
                          <tr key={product.product_id}>
                            <td>{index + 1}</td>
                            <td style={{ whiteSpace: 'normal' }}>{product.product_name}</td>
                            <td>
                              {product.is_box ? `Box qty (${product?.box_qty})` : product.qty}
                            </td>
                            <td >
                              <input type="number" className="w-100"
                                step="any"
                                name={product.is_box ? "box_sales_cost" : "price"}
                                value={product.is_box ? Number(product?.box_sales_cost) / Number(product?.box_qty) : Number(product?.price)}
                                defaultValue={product.avg_sales_price}
                                onChange={(e) => {
                                  const { name, value } = e.target
                                  handleChange(index, value, name)
                                }}
                                min={0} />
                            </td>
                            <td>
                              <select className="w-100" name="discount_type" value={product.discount_type} onChange={(e) => handleChange(index, e.target.value, e.target.name)}>
                                <option value={0}>Cash</option>
                                <option value={1}>Percentage</option>
                              </select>
                            </td>
                            <td>
                              <input defaultValue={0} type="number" className="w-100"
                                step="any"
                                name={"discount"}
                                value={product.discount}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  const numericValue = Number(value);
                                  if (numericValue > 95) return;
                                  handleChange(index, numericValue, name);
                                }}
                                min={0} />
                            </td>
                            <td>
                              <input defaultValue={0} type="number" className="w-100"
                                step="any"
                                name={"warranty"}
                                value={product.warranty}
                                onChange={(e) => {
                                  const { name, value } = e.target
                                  if (value > 95) { return }
                                  handleChange(index, value, name)
                                }}
                                min={0} />
                            </td>
                            <td>
                              <img
                                src="/assets/images/icons/add.png"
                                className="m-1"
                                onClick={() => {
                                  if (product?.is_quataion) {
                                    openSerialModal(product)
                                  } else {
                                    setshowSerialnumber(true)
                                    setSelectedSerials(product.serial_number ? JSON.parse(product?.serial_number) : []);
                                  }
                                }}
                                width={"20px"}
                              />
                            </td>
                            <td >
                              <input defaultValue={0} type="number" className="w-100"
                                name={"total"}
                                // value={product.is_box ? product?.box_sales_cost : product?.total}
                                value={product?.total}
                                disabled={true}
                                onChange={(e) => {
                                  const { name, value } = e.target
                                  handleChange(index, value, name)
                                }}
                                min={0} />
                            </td>
                            <td>
                              <a
                                onClick={() => handleRemoveProduct(index)}
                              >
                                <img src='/assets/images/icons/delete.png' width={'15px'} />
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="9"
                            style={{
                              height: "30vh"
                            }}
                          >No products selected.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <SerialNoGenerate
              show={sNoShow}
              onClose={() => setSNoShow(false)}
              count={count}
              index={sIndex}
              data={sData}
              // handleSubmit={handleAddRow}
              handleUpdate={handleChange}
            />

            <div className="mx-0" style={{ width: "100%", height: "20vh", background: "white" }}>
              <div className="d-flex w-100 h-100 justify-content-center">
                <div className="col-6">
                  <div className="card card-body p-2 rounded-0">
                    <div className="d-flex justify-content-between mb-2">
                      <span>Subtotal</span>
                      <span>{parseFloat(totals.priceTotal)?.toFixed(3)}</span>

                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span className='me-2'>
                        Discounts
                      </span>
                      <span>
                        {parseFloat(parseFloat(totals.withoutTax) - parseFloat(totals.priceTotal))?.toFixed(3)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <span>Tax ({vat}%)</span>
                      <span>{totals.taxAmount}</span>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card card-body p-2 rounded-0">

                    <div className="d-flex justify-content-between mb-1">
                      <span>Return</span>
                      <span className='text-danger'>{
                        ReturnItem.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0)?.toFixed(3)
                      }</span>
                    </div>
                    {/* <div className="d-flex justify-content-between mb-1">
                      <span className='me-2'>
                        Over-Discounts
                      <input
                      type='Number'
                      className='form-control form-control-sm d-inline-block '
                      style={{width:"30%"}}
                      placeholder='%'
                      value={Overdiscount}
                      min={0}
                      max={90}
                      onChange={(e) => setOverdiscount(Number(e.target.value))}
                      />
                      </span>
                      <span>{((totals.withTax - discount) * Overdiscount / 100).toFixed(3)}</span>
                    </div> */}
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <div className='me-2'>
                        <label>Over-Discounts</label>
                        <div className="d-flex align-items-center">
                          <input
                            type='number'
                            className='form-control form-control-sm me-2'
                            style={{ width: "80px" }}
                            placeholder='0'
                            value={Overdiscount}
                            min={0}
                            max={OverdiscountType === "%" ? 90 : 9999}
                            onChange={(e) => setOverdiscount(Number(e.target.value))}
                          />
                          <select
                            className='form-select form-select-sm'
                            style={{ width: "70px" }}
                            value={OverdiscountType}
                            onChange={(e) => setOverdiscountType(e.target.value)}
                          >
                            <option value="%">%</option>
                            <option value="RO">INR</option>
                          </select>
                        </div>
                      </div>

                      <span>
                        {overDiscountAmount.toFixed(3)}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
                      <span className="m-0">Amount Due</span>
                      <span
                        className={`m-0 ${amountDue2 >= 0 ? 'text-success' : 'text-danger'}`}
                      >
                        {amountDue2}
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-0" style={{ width: "30vw", height: "90vh", background: "white" }}>
            <div className="mx-0" style={{ width: "100%", height: "75vh", background: "white", overflow: 'hidden', overflowY: 'scroll' }}>
              <div className='row-gap-2 d-flex flex-wrap mt-1'>
                <div className="mx-1 d-flex align-items-center justify-content-center cursor-pointer"
                  onClick={() => Resetbutton()}
                  style={{ width: '100%', height: '40px', background: "#bdbd13" }}>
                  <h6 className='text-center text-white m-0'>Reset</h6>
                </div>
                <div className="mx-1 d-flex align-items-center justify-content-center cursor-pointer"
                  onClick={() => setShow(true)}
                  style={{ width: '100%', height: '40px', background: "#cc0606" }}>
                  <h6 className='text-center text-white m-0'
                  >Replace</h6>
                </div>
                <div
                  className="mx-1 d-flex align-items-center justify-content-center cursor-pointer"
                  onClick={() => setQuotation(true)}
                  // onClick={() => {alert("Quotation Process Is Under Development")}}
                  style={{ width: '100%', height: '40px', background: "green" }}>
                  <h6 className='text-center text-white m-0'
                  >Quotation</h6>
                </div>
              </div>

              <div className="container mt-3">
                <h5 className="mb-3 font-14">Return Items</h5>
                <div className="row g-3">
                  {Array.isArray(ReturnItem) && ReturnItem?.map((item, index) => (
                    <div className="col-md-12 mb-0 mt-1" key={item.id}>
                      <div className="card shadow-sm border-0 rounded-3 p-2 mb-0">
                        <div className="d-flex mb-0 justify-content-between align-items-center">
                          <h6 className="mb-0 font-13">{item.product_name}</h6>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeItem(item.id)}
                          >
                            X
                          </button>
                        </div>
                        <p className="mb-0 font-13" style={{ marginTop: "-5px" }}>Qty: {item.returnQty}</p>
                        <p className="fw-bold mb-0 font-13">Amount: {item.returnAmount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="mx-0 flex-column d-flex justify-content-end pb-3" style={{ width: "100%", height: "15vh", background: "white" }}>
              <div className="d-flex justify-content-center px-1" style={{ height: '50px' }}>
                <button
                  disabled={selectedProducts.length == 0}
                  onClick={() => {
                    handleOpenModal();
                  }}
                  className="btn btn-dark d-flex align-items-center justify-content-center rounded-0 w-50 text-normal">
                  <i className="bi bi-cash-stack text-small"></i> Print
                </button>

                <button
                  disabled={selectedProducts.length == 0}
                  onClick={() => {
                    Paybutton()

                  }}
                  className="btn btn-success d-flex align-items-center justify-content-center rounded-0 w-50 text-normal">
                  <i className="bi bi-cash-stack text-small"></i> Pay
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade show"
          style={{ display: show ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {searchCustomerTerm ? searchCustomerTerm : <span className="text-danger">Select Customer Name</span>}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShow(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  {/* {Array.isArray(OderList) && <InvoiceSearch OderList={OderList.filter((order) => order.type != "2")} />} */}

                  {Array.isArray(OderList) &&
                    InvoiceSearch(
                      OderList.filter((order) => order.type != "2"),
                      ReturnItem,
                      setReturnItem,
                    )}
                  <div className="mt-5 ">
                    <button
                      type="button"
                      className="btn btn-secondary me-2 float-end"
                      onClick={() => setShow(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade show"
          style={{ display: Quotation ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {<span className="text-danger">Select Quotation</span>}
                </h5>


                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setQuotation(false)}
                ></button>
              </div>
              <div className="modal-body p-2">
                <div className='p-2 '>
                  <div style={{ position: 'relative', display: 'inline-block' }} className='w-100' >
                    <input
                      type="text "
                      className='w-100 form-control'
                      placeholder="Search | Quotation No | Customer Name"
                      value={searchTerm1}
                      onChange={(e) => {
                        setSearchTerm1(e.target.value)
                        handleSearch(e.target.value)
                      }}
                      style={{
                        borderRadius: '1px',
                        border: '1px solid #ccc',
                        padding: '8px 20px 6px 12px',
                      }}
                    />
                    <img
                      src="/assets/images/icons/search.png"
                      alt="Search Icon"
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        height: '18px',
                        pointerEvents: 'none',
                      }}
                    />
                  </div>
                </div>
                <table className=" table min-w-full  border border-gray-300 mb-0">
                  <thead >
                    <tr className="bg-gray-200">
                      <th className="border px-2 py-2">Quotation No</th>
                      <th className="border px-2 py-2">Customer Name</th>
                      <th className="border px-2 py-2">Date</th>
                      <th className="border px-2 py-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(QuotationList) && QuotationList.length > 0 ? (
                      QuotationList
                        .filter((data) => data.status !== "1")
                        .map((item) => (
                          <tr key={item.id} className="border">
                            <td className="border px-2 py-2">{item.quotation_number}</td>
                            <td className="border px-2 py-2">{item.customer_name}</td>
                            <td className="border px-2 py-2">{item.date}</td>
                            <td className="border px-2 py-2">
                              <button
                                onClick={() => GetPurchaseData(item)}
                                className="bg-primary text-white px-3 py-1 rounded hover:bg-blue-600"
                              >
                                Add
                              </button>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center p-4">
                          No quotations available
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>


                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
                <div className="mt-5 ">
                  <button
                    type="button"
                    className="btn btn-secondary me-2 float-end"
                    onClick={() => setQuotation(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade show"
          style={{ display: returnShow ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content p-3">
              {/* Modal Header */}
              <div className="modal-header border-0">
                <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  // onClick={() => setReturnShow(false)}
                  onClick={() => setCashShow(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className='row'>
                  <div className='col-6'>
                    <div className="phone-pad-container">
                      <input
                        type="text"
                        value={input}
                        readOnly
                        className="phone-input"
                        disabled={parseFloat(getAmountDue()) < 0}
                      />
                      <div className="grid-container">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0, "⌫"].map((key, index) => (
                          <button
                            key={index}
                            className="key-btn"
                            onClick={() => {
                              if (parseFloat(getAmountDue()) > 0) {

                                key === "⌫"
                                  ? handleBackspace()
                                  : key === "✔"
                                    ? handleConfirm()
                                    : handleClick(key)
                              }
                            }}
                          >
                            {key}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="space-y-5 col-6">
                    <div key={"name"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                      <label className="text-sm font-semibold text-gray-700 w-100 mt-2">{"Total (INR)"}</label>
                      <input
                        type={"text"}
                        name={"name"}
                        value={getAmountDue()}
                        disabled={true}
                        className="col-span-2 w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                      />

                      <label className="text-sm font-semibold text-gray-700 w-100 mt-2">{"Customer Given (INR)"}</label>
                      <input
                        type={"text"}
                        name={"name"}
                        value={input}
                        disabled={true}
                        className="col-span-2 w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                      />

                      <label className="text-sm font-semibold text-gray-700 w-100 mt-2">{"Return (INR)"}</label>
                      <input
                        type={"text"}
                        name={"name"}
                        disabled={true}
                        value={getReturnValue()}
                        className="col-span-2 w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                      />

                      <label className="text-sm font-semibold text-gray-700 w-100 mt-2">{"Remaining (INR)"}</label>
                      <input
                        type={"text"}
                        name={"name"}
                        disabled={true}
                        value={getReminingValue()}
                        className="col-span-2 w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                      />

                      <button
                        onClick={() => {
                          handleSubmit();
                        }}
                        disabled={!input}
                        // disabled={parseFloat(getAmountDue()) > 0 && !(parseFloat(input) >= parseFloat(getAmountDue() || 0))}
                        className="w-full mt-2 btn btn-success text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition">
                        Pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-body d-none">
                <form>
                  <div className="container-fluid">
                    <div className="row g-3">
                      {Object.keys(values).map((key) => (
                        <div className="col-12 col-md-6 d-flex align-items-center" key={key}>
                          <span className="me-2 fw-semibold font-13">{key} x</span>
                          <input
                            type="text"
                            className="form-control text-end"
                            value={values[key]}
                            onChange={(e) => handleChange1(e, key)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Total Display */}
                  <div className="d-flex justify-content-between align-items-center mt-4 border-top pt-3">
                    <span className="fw-semibold fs-5">Total:</span>
                    <div className="border p-2 rounded fw-bold fs-5 text-primary">
                      {calculateTotal()}
                    </div>
                  </div>

                  {/* Modal Footer - Buttons */}
                  <div className="d-flex justify-content-end mt-4">
                    <button type="button" className="btn btn-secondary me-2" onClick={() => setReturnShow(false)}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => handleSubmit()}>
                      Pay
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>

      <CustomerAddModal
        showCustomer={showCustomer}
        setShowCustomer={setShowCustomer}
        onReqCustomer={fetchSuppliers} />

      <PaymentModal
        show={showPayModal}
        onClose={() => setShowPayModal(false)}
        onSelectPayment={handlePaymentType} />

      <CashModal
        show={cashShow}
        onClose={() => setCashShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        CustomerId={CustomerId}
        isSales={true}
        handleSubmit={handleSubmit}
      />

      <CashCardModal
        show={cashCardShow}
        onClose={() => setCashCardShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handleSubmit}
      />

      <CardModal
        show={cardShow}
        onClose={() => setCardShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        CustomerId={CustomerId}
        isSales={true}
        handleSubmit={handleSubmit}
      />

      <div
        className="modal fade show"
        style={{ display: printOpen ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-3" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
            <div className="modal-header border-0">
              <h4 className="modal-title fw-bold" style={{ fontFamily: "Poppins" }}>
                Select Your Default Printer
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => { setPrintOpen(false) }}
              ></button>
            </div>

            <div className="modal-footer border-0 d-flex justify-content-center">
              <button className="btn btn-success" onClick={() => { handleSelectPrinter("0") }}>
                Thermal Printer
              </button>
              <button
                type="button"
                className="btn btn-info me-2"
                onClick={() => handleSelectPrinter("1")}
              >
                A4 Sheet Printer
              </button>
            </div>
          </div>
        </div>

      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        tabIndex={-1}
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
        aria-hidden={!showModal}
      >
        <div style={successModal ? { position: "absolute", top: "-100%" } : {}} className={`modal-dialog ${printerType == "0" ? 'modal-sm' : 'modal-lg'}`} role="document">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            {printerType == "0" &&
              <div ref={componentRef} style={styles.body}>
                <div style={styles.textCenter}>
                  <img src="assets/images/tech_logo.webp" alt="Company Logo" style={styles.logo} />
                  <div style={styles.flexBetween}>
                    <h6 style={styles.bold}>Sales Invoice</h6>
                    <h6 style={styles.bold} dir="rtl">فاتورة المبيعات</h6>
                  </div>
                  <hr style={styles.hr} />
                  <h6 style={styles.bold}>TOP TECNO</h6>
                  <p className="mb-2">Old Alfair Building, Al Khoudh Souq, Muscat</p>
                  {/* <p className="mb-1">CR: 1026299</p> */}
                </div>

                <div style={styles.textStart}>
                  <p className="mb-2"><strong>TRN No:</strong> {Customer.find(item => item.customer_id === CustomerId)?.TRN_no || ""}</p>
                  <p className="mb-2"><strong>Contact No:</strong> {Customer.find(item => item.customer_id === CustomerId)?.phone || ""}</p>
                  <hr style={styles.hr} />
                </div>

                <div className="mt-2" style={styles.textStart}>
                  <p className="mb-2"><strong>Invoice No.:</strong> {unqui}</p>
                  <p className="mb-2"><strong>Invoice Date:</strong> {customDate}</p>
                  <p className="mb-2"><strong>Payment Mode:</strong>  {purchaseUnit === "1" ? "Cash" : purchaseUnit === "2" ? "Credit" : ""}</p>
                  <hr style={styles.hr} />
                </div>

                <table style={styles.table}>
                  <thead>
                    <tr style={styles.borderbottom}>
                      <th className="text-start"><span style={styles.textStart}>Item</span><br /><span style={styles.textStart} dir="rtl">الصنف</span></th>
                      <th className="text-start"><span style={styles.textStart}>Rate</span><br /><span style={styles.textStart} dir="rtl">السعر</span></th>
                      <th className="text-start"><span style={styles.textStart}>Qty</span><br /><span style={styles.textStart} dir="rtl">الكمية</span></th>
                      <th className="text-end"><span style={styles.textStart}>Amount</span><br /><span style={styles.textStart} dir="rtl">المبلغ</span></th>
                    </tr>
                  </thead>
                  {Array.isArray(selectedProducts) && selectedProducts.length > 0 &&
                    <tbody>
                      {selectedProducts?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item.product_name}</p></td>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item.price}</p></td>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item?.is_box == 1 ? `${item.boxqty} (x${Number(item.qty) || 0 / Number(item.boxqty) || 0})` : item.qty}</p></td>
                          <td className="text-end"><p className="mb-2" style={styles.fontSize}>{item.total}</p></td>
                        </tr>
                      ))}
                    </tbody>
                  }

                  {Array.isArray(ReturnItem) && ReturnItem.length > 0 &&
                    <tbody style={{ borderTop: "1px solid black" }}>
                      <tr>
                        <p className="text-start font-weight-2 my-2"> Return Product</p>
                      </tr>
                      {ReturnItem?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item.product_name}</p></td>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item.sales_price}</p></td>
                          <td className="text-start"><p className="mb-2" style={styles.fontSize}>{item?.qty}</p></td>
                          <td className="text-end"><p className="mb-2" style={styles.fontSize}>{item.amount_per_price}</p></td>
                        </tr>
                      ))}
                    </tbody>
                  }
                </table>

                <hr style={styles.hr} />
                <div className="mt-2" style={styles.flexBetween}>
                  <div>
                    <p className="text-start mb-2"><strong>Items:</strong> {selectedProducts?.length || 0}</p>
                    <p className="text-start mb-2"><strong>Cash/Card:</strong> {input}</p>
                  </div>
                  <div style={styles.textEnd}>
                    <p className="mb-2">'</p>
                    {/* <p className="mb-2"><strong>Qty:</strong> 1.00</p> */}
                    <p className="mb-2"><strong>Change:</strong> {getReturnValue()}</p>
                  </div>
                </div>
                <hr style={styles.hr} />
                <div className="mt-2 mb-2" style={styles.border}>
                  <div style={styles.flexBetween}><p className="mb-2"><strong>Sub Total:</strong></p><p className="mb-2">{parseFloat(totals.priceTotal)?.toFixed(3)}</p></div>
                  <div style={styles.flexBetween}><p className="mb-2"><strong>Discount:</strong></p><p className="mb-2">{parseFloat(parseFloat(totals.withoutTax) - parseFloat(totals.priceTotal))?.toFixed(3)}</p></div>
                  <div style={styles.flexBetween}><p className="mb-2"><strong>VAT {vat}%:</strong></p><p className="mb-2">                      <span>{totals.taxAmount}</span>
                  </p></div>
                  <div style={styles.flexBetween}><p className="mb-2"><strong>Return:</strong></p><p className="mb-2">{ReturnItem.reduce((acc, item) => acc + Number(item?.amount_per_price || 0), 0)?.toFixed(3)}</p></div>
                  <div style={styles.flexBetween}><h6 style={styles.bold}>Grand Total:</h6><h6 style={styles.bold}>{amountDue2}</h6></div>
                  {/* <div style={styles.flexBetween}><h6 style={styles.bold}>Grand Total:</h6><h6 style={styles.bold}>{(amountDue - ReturnItem.reduce((acc, item) => acc + parseInt(item?.amount_per_price || 0), 0)).toFixed(3)}</h6></div> */}
                </div>
              </div>}

            {printerType == "1" &&
              <div className="" ref={modalContentRef}>
                {/*  model  from  */}
                <div className="row mx-3 mt-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="col-md-1">
                      <img
                        src={company_logo || "assets/images/tech_logo.webp"}
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div>

                    {/* <div className='mb-2'>
                      <img
                        src="assets/images/arabic.jpg"
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div> */}
                  </div>

                  <div className="col-12 text-center mt-2">
                    <p className="fw-bold font-14 mb-0">
                      {companyInfo?.address}
                    </p>
                    <p className="fw-medium font-13 mb-0">
                      Mobile: {companyInfo?.phone} |
                      Email: {companyInfo?.email}
                    </p>
                  </div>
                </div>
                {/* Invoice Title */}
                <div className="row">
                  <div className="col text-center">
                    <h3
                      className="fw-bold mt-2"
                      style={{ textDecoration: "underline" }}
                    >
                      فاتورة
                    </h3>
                    <h3 className="fw-bold">INVOICE</h3>
                  </div>
                </div>

                <div className="row border-top border-bottom pt-3  mx-3 pb-2">
                  <div className="col-6">
                    <div
                      className="p-2 "
                      style={{
                        border: ".8px solid #dee2e6",
                        minHeight: 150,
                      }}
                    >
                      <h6 className="fw-bold ">
                        {newpurchasequtation?.id?.slice(0, 2).toUpperCase() === "PO"
                          ? "Supplier Details:"
                          : "Customer Details:"}
                      </h6>
                      <div className="d-flex justify-content-between mt-3">
                        <p className="fw-semibold font-13 mb-1">Name:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                        // style={{ textDecoration: "underline" }}
                        >
                          {Customer.find(item => item.customer_id === CustomerId)?.name || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-semibold font-13 mb-1">Email:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                        // style={{ textDecoration: "underline" }}
                        >
                          {Customer.find(item => item.customer_id === CustomerId)?.contact_email || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-semibold font-13 mb-1">Address:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                        // style={{ textDecoration: "underline" }}
                        >
                          {Customer.find(item => item.customer_id === CustomerId)?.branch || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-semibold font-13 mb-1">Phone:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                        // style={{ textDecoration: "underline" }}
                        >
                          {Customer.find(item => item.customer_id === CustomerId)?.phone || ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <table className="table  table-bordered text-center align-middle m-0 ">
                      <tbody>
                        <tr className='hight-header'>
                          <td className="text-start fw-bold">Inv No:{unqui}</td>
                          <td className="text-start fw-bold">Date: {customDate}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table table-bordered text-center align-middle">
                      <tbody>
                        <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              L.P.O No:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {LPONO}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              Sales Person:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {user.full_name}
                            </p>
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              Payment Terms:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {purchaseUnit == "1" ? "Cash" : "Credit"}
                            </p>
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-4 mx-4">
                  <div
                    className="col-md-12"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
                      backgroundSize: "60%",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="table-responsive">
                      <table className=" border table-sm table-bordered w-100">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "5%" }}>
                              <span>الرقم</span>
                              <br />
                              Sl. No.
                            </th>
                            <th style={{ width: "35%" }}>
                              <span>التفاصيل</span>
                              <br />
                              Particulars
                            </th>
                            <th style={{ width: "5%" }}>
                              <span>الكمية</span>
                              <br />
                              Qty
                            </th>
                            <th style={{ width: "15%" }}>
                              <span>سعر الوحدة</span>
                              <br />
                              Unit Price
                            </th>
                            <th style={{ width: "10%" }}>
                              <span>الخصم</span>
                              <br />
                              Discount
                            </th>
                            <th style={{ width: "10%" }}>
                              <span>الخصم</span>
                              <br />
                              Warranty
                            </th>
                            <th style={{ width: "20%" }}>
                              <span>المبلغ الإجمالي</span>
                              <br />
                              Total Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>

                          {Array.isArray(selectedProducts) && selectedProducts?.map((item, index) => {
                            const serials = JSON.parse(item.serial_number || "[]");
                            const unitPrice = Number(item.price); // per unit
                            const qty = Number(item.is_box ? item.boxqty : item.qty);
                            const discountValue = parseFloat(item.discount || 0);
                            const discountAmount =
                              item.discount_type == "1"
                                ? (unitPrice * discountValue) / 100
                                : discountValue;
                            const finalPrice = unitPrice - discountAmount;

                            return (
                              <React.Fragment key={index}>
                                <tr className="bg-transparent">
                                  <td className="bg-transparent">{index + 1}</td>
                                  <td className="fw-semibold" style={{ whiteSpace: 'normal', maxWidth: "240px" }}>{item.product_name}
                                    {serials && serials.length > 0 ? (
                                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                                        {serials.map((serial) => serial.serial_number).join(", ")}
                                      </div>
                                    ) : (
                                      <div style={{ fontSize: "0.80rem", color: "#ff0000", opacity: 0.55 }}>
                                        No serial Number Available
                                      </div>
                                    )}
                                  </td>
                                  <td className="fw-semibold">
                                    {item?.is_box == 1
                                      ? `${item.boxqty} (x${Number(item.qty) ||
                                      0 / Number(item.boxqty) ||
                                      0
                                      })`
                                      : item.qty}
                                  </td>
                                  <td className="fw-semibold">{item.price}</td>

                                  <td className="fw-semibold">
                                    {item.discount || 0}{" "}
                                    {item.discount_type == "1" ? "%" : "RO"}
                                  </td>
                                  <td className="fw-semibold">
                                    {item.warranty || "-"}
                                  </td>
                                  <td className="fw-semibold" >{Number(item.total).toFixed(3)} </td>

                                </tr>

                                {/* {
                                                                Array.from({ length: qty }).map((_, i) => (
                                                                  <tr key={`expanded-${index}-${i}`} className="bg-light text-muted">
                                                                    <td className="text-muted bg-light"></td>
                                                                    <td className="text-muted bg-light">{item.product_name} - S.No: {serials[i] || ''}</td>
                                                                    <td className="text-muted bg-light">1</td>
                                                                    <td className="text-muted bg-light">{unitPrice}</td>
                                                                    <td className="fw-semibold">
                                                                      {item.discount || 0}{" "}
                                                                      {item.discount_type == "1" ? "%" : "RO"}
                                                                    </td>
                            
                            
                                                                    <td className="text-muted bg-light">{finalPrice}</td>
                                                                  </tr>
                                                                ))} */}
                              </React.Fragment>
                            );
                          })}
                          {Array.isArray(ReturnItem) && ReturnItem.length > 0 &&
                            <tr>
                              <td colSpan="6" className="text-center">
                                <strong>Return Products</strong>
                              </td>
                            </tr>
                          }

                          {Array.isArray(ReturnItem) &&
                            ReturnItem.map((item, index) => (
                              <tr key={`additional-product-${index}`}>
                                <td className='text-semibold'>{selectedProducts?.length + index + 1}</td>
                                <td className='text-semibold'>{item?.product_name || "N/A"}</td>
                                <td className='text-semibold'>{item?.returnQty || "0"}</td>
                                <td className='text-semibold'>{item?.sales_price}</td>
                                <td className='text-semibold'>
                                  {(((parseFloat(item.discount) || 0) / Number(item.qty)) * Number(item?.returnQty)).toFixed(2)}{" "}
                                  {item.discount_type == "1" ? "%" : "RO"}
                                </td>
                                <td className='text-semibold'>{item?.warranty || "-"}</td>
                                <td>{"- " + item?.returnAmount}</td>
                              </tr>
                            ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <br />
                          </tr>

                          <tr>
                            <td className="bg-transparent text-end text-semibold" colSpan={6}>Total</td>
                            <td className="bg-transparent text-semibold">
                              {totals?.withoutTax}
                            </td>
                          </tr>
                          <tr>
                            <td className="bg-transparent text-end text-semibold" colSpan={6}>
                              Over Discount (-)
                              {OverdiscountType === "%" ? ` (${Overdiscount}%)` : ""}
                            </td>
                            <td className="bg-transparent text-semibold">
                              {OverdiscountType === "%"
                                ? ((totals.withTax - discount) * Overdiscount / 100).toFixed(3)
                                : Overdiscount.toFixed(3)}
                            </td>
                          </tr>


                          <tr>
                            <td className="bg-transparent text-end text-semibold" colSpan={6}>Tax (+)</td>
                            <td className="bg-transparent text-semibold">
                              {totals?.taxAmount}
                            </td>
                          </tr>
                          {ReturnItem.length > 0 && <tr>
                            <td className="bg-transparent text-end text-semibold" colSpan={6}>Return (-)</td>
                            <td className="bg-transparent text-semibold text-danger">
                              {ReturnItem.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0)}
                            </td>
                          </tr>}
                          <tr>
                            <td className="bg-transparent text-end text-semibold" colSpan={6}>Grand Total</td>
                            <td className="bg-transparent text-semibold">
                              {amountDue2}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={6} className="text-center fw-bold px-2">Payment Detail</td>
                          </tr>
                          {invoiceData && invoiceData.length > 0 &&
                            invoiceData.map((data) => (
                              <tr>
                                <td colSpan={6} className="text-end fw-bold px-2 ">{data?.mop}</td>
                                <td colSpan={1} className="text-center text-semibold">{data?.amount}</td>
                              </tr>
                            ))
                          }
                        </tfoot>
                      </table>
                      <table className="table table-bordered text-center align-middle mt-0 bg-transparent">
                        <tbody className="bg-transparent">
                          <tr className="bg-transparent">
                            <td className="text-start bg-transparent text-wrap">
                              <p className="fw-bold text-start mb-0 w-100">
                                Amount In Words:
                                {AmountInWords(amountDue2)}

                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row border-top border-bottom py-3 mx-3">
                  <div className="col-10 col-md-4 d-flex">
                    <div
                      className="p-2 flex-fill d-flex flex-column"
                      style={{ border: ".8px solid #dee2e6" }}
                    >
                      <h6 className="fw-bold">
                        Terms & Condition
                      </h6>
                      <p className="mt-2 fs-8 flex-grow-1">{data?.terms_conditions}</p>

                    </div>
                  </div>

                  <div className="col-12 col-md-4 d-flex">
                    <div
                      className="p-2 flex-fill d-flex flex-column"
                      style={{ border: ".8px solid #dee2e6" }}
                    >
                      <h6 className="fw-bold">
                        Bank Account
                      </h6>
                      <p className="mt-2  fs-6 flex-grow-1">
                        <p> Name :{data?.bank_name || "N/A"}</p>
                        Branch:{data?.bank_branch || "N/A"}
                        <br />
                        {data?.account_no ? `A/C No: ${data.account_no}` : "N/A"}

                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 d-flex">
                    <div
                      className="p-2 flex-fill d-flex flex-column"
                      style={{ border: ".8px solid #dee2e6" }}
                    >
                      <h6 className="fw-bold">
                        For Top Tecno
                      </h6>
                      <p className="mt-2  fs-6 flex-grow-1">
                        {data?.shop_title || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>}

            <div className="modal-footer mx-1 mt-4">
              <button
                type="button"
                className={"btn btn-info"}
                onClick={() => { printerType == "0" ? handlePrint1() : handlePrint(modalContentRef) }}>
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesWindow;
